import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { dGet } from '@core/utils'
import { PreviewModal, Carousel } from 'hlj-components'
import Img from '@UI/Img'
import style from './style.module.less'
import cls from 'classnames'

const Item = ({ styleProp, top, pcIcon, achievement, tips, bottom }) => {
  return (
    <div className={style.achievementBox} style={styleProp}>
      <Img src={pcIcon} className={style.img} style={styleProp} />
      <div className={cls(style.info, 'center')} style={{ top }}>
        <div className={style.title}>恭喜解锁</div>
        <div className={style.achievement}>{achievement}</div>
        <div className={style.tip}>Tips：{tips}</div>
        {bottom && (
          <div className={style.bottom}>
            <span>{bottom}</span>
          </div>
        )}
      </div>
    </div>
  )
}

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      ultimateUnlockVisible,
      closeUltimateUnlockModal,
      unlockVisible,
      closeUnlockModal,
      taskPageData
    } = this.props.store

    const { achievement, tips, startTime, pcIcon } = dGet(
      taskPageData,
      'ultimateUnlock',
      {}
    )

    const unlockList = dGet(taskPageData, 'unlock', [])
    const ultimateUnlockStyle = { width: 260, height: 359 }
    const boxStyle = { width: 268, height: 312 }

    return (
      <>
        <PreviewModal
          visible={ultimateUnlockVisible}
          onCancel={closeUltimateUnlockModal}
        >
          <Item
            styleProp={ultimateUnlockStyle}
            pcIcon={pcIcon}
            tips={tips}
            achievement={achievement}
            bottom={
              <span>
                计划于 {startTime}
                正式生效
              </span>
            }
            top={309}
          />
        </PreviewModal>

        <PreviewModal visible={unlockVisible} onCancel={closeUnlockModal}>
          <div style={boxStyle}>
            <Carousel className={style.carousel} infinite={false} dots={false}>
              {unlockList.map(({ achievement, tips, pcIcon }, i) => (
                <div key={i}>
                  <Item
                    styleProp={boxStyle}
                    pcIcon={pcIcon}
                    tips={tips}
                    achievement={achievement}
                    top={174}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </PreviewModal>
      </>
    )
  }
}
